import { normalizeTime } from '../utils/timeUtils';

function stripStepPrefixForStorage(stepText) {
  if (typeof stepText !== 'string') return stepText || '';
  const trimmed = stepText.trimStart();
  if (trimmed.startsWith('✔ ')) {
    return trimmed.slice(2);
  }
  if (trimmed.startsWith('-> ')) {
    return trimmed.replace(/^->\s+/u, '');
  }
  if (trimmed.startsWith('➕ ')) {
    return trimmed.slice(2);
  }
  return stepText;
}

export const buildPayload = ({
  parsed,
  rowLabels,
  cellStates,
  comments,
  colIndex,
  providerColumns,
  metaInfo,
  info
}) => {
  const data = rowLabels
    .filter(label => label !== 'Send')
    .map((label, rowIndex) => {
      const key = `${rowIndex}_${colIndex}`;
      const manualState = cellStates[key];
      const userComment = comments[key];

      let approved;
      let doctorsComment;
      let step = '';
      let doc_ref = '';
      let kind = '';

      if (label === 'Title') {
        approved = manualState === 'ok' ? true
                 : manualState === 'bad' ? false
                 : (parsed?.title_approved ?? false);

        doctorsComment = (manualState || userComment)
          ? (userComment || '')
          : (parsed?.title_comment || '');
        step = parsed?.title || '';
      } else if (label === 'Description') {
        approved = manualState === 'ok' ? true
                 : manualState === 'bad' ? false
                 : (parsed?.description_approved ?? false);

        doctorsComment = (manualState || userComment)
          ? (userComment || '')
          : (parsed?.description_comment || '');
        step = parsed?.description || '';
      } else {
        const stepIndex = rowIndex - 1;
        const s = parsed?.treatment_steps?.[stepIndex];

        approved = manualState === 'ok' ? true
                 : manualState === 'bad' ? false
                 : (s?.approved ?? false);

        doctorsComment = (manualState || userComment)
          ? (userComment || '')
          : (s?.doctorsComment || '');

        step = stripStepPrefixForStorage(s?.step || '');
        doc_ref = s?.doc_ref || '';
        kind = s?.source || '';
      }
      console.log('info =', info);

      // CommentsEntry:
      // Section: str
      // Approved: bool
      // DoctorsComment: Optional[str] = ""
      // step: Optional[str] = None
      // doc_ref: Optional[str] = None
      // kind: Optional[str] = None

      return {
        Section: label,
        Approved: approved,
        DoctorsComment: doctorsComment,
        step,
        doc_ref,
        kind
      };
    });

  const correctedAt = normalizeTime(new Date().toISOString());

  // console.log('id =', metaInfo.patnr_id);
  // console.log('created_at =', normalizeTime(metaInfo.time));
  // console.log('comments =', data);
  // console.log('assistant =', metaInfo.username);
  // console.log('corrected_at =', correctedAt);

  // ColumnEmmaPayload:
  //   id: int
  //   created_at: datetime
  //   input_document: str
  //   comments: List[CommentsEntry]
  //   assistant: str
  //   corrected_at: datetime

  return {
    id: metaInfo.patnr_id,
    input_document: info,
    created_at: normalizeTime(metaInfo.time),
    comments: data,
    assistant: metaInfo.username,
    corrected_at: correctedAt,
  };
};